import { useNavigate } from "react-router-dom";
import logo from '../assets/img/logo.png'

const Logo = ( { isMobile } ) => {

    const history = useNavigate()

    const handleHome = () => {
        history('/')
    }

    return (
        <img
            src={logo}
            alt="logo"
            style={{ cursor: 'pointer', width: isMobile ? '120px' : '200px' }}
            onClick={handleHome}
        /> 
    )

}

export default Logo;